import Camera, { FACING_MODES, IMAGE_TYPES } from './components';

export {
  Camera,
  FACING_MODES,
  IMAGE_TYPES
};

export default Camera;



// WEBPACK FOOTER //
// ./src/lib/index.js